import { Injectable } from '@angular/core';
import { CreateMessageState } from './createMessage.state';
import { MessagesService } from './messages.service';
import { map } from 'rxjs/operators';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { Observable, observable, forkJoin } from 'rxjs';
// import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { MessageBody } from '../interfaces/MessageBody';


@Injectable({
  providedIn: 'root'
})

export class CreateMessageFacade {

  constructor(private createMessageState: CreateMessageState, private messageApi: MessagesService,
    private dataService: DataService
  ) {

  }

  loadUsers() {
    this.messageApi.getUsersByRole().subscribe(data => {      
      this.setAllUsers(data)
    })
  }

  setAllUsers(users) {
    this.createMessageState.setAllUsers(users)
  }

  getAllUsers$() {
    return this.createMessageState.getAllUsers()
  }

  getAllGrades$() {
    return this.dataService.getAllGrades();
  }

  setFilteredUsers(users) {
    this.createMessageState.filteredUsers.next(users);
  }

  getFilteredUsers$() {
    return this.createMessageState.filteredUsers.asObservable();
  }

  getCombined$() {
    return forkJoin(
      this.messageApi.getAllGates(),
      this.messageApi.getAllRoutes(),
      this.messageApi.getAllGrades()
    ).pipe(map(
      ([gates, routes, grades]) => {
        return { gates, routes, grades };
      }
    ))
  }
  filterUsers(checkedList) { 
    let paramsAndValues = checkedList.map(x => ({ type: x.type, value: x.value , id:x.id }))
    let gateNames = []
    let grades = []
    let routes = []
    let classes = [];

    paramsAndValues.forEach(element => { 
      switch (element.type) {
        case "gates":
          gateNames.push(element.id)
          break;

        case "grade_name":
          grades.push(element.id)
          break;

        case "class_name":
          classes.push(element.id)
          break;

        case "route_name":
          routes.push(element.value)
          break

      }

    })


    let roleParams = {
      'filter[role]': [... new Set(checkedList.filter(x => x.role)
        .map(x => x.role))]
    }


    let roleQuery = Object.keys(roleParams).map(key => {
      if (Array.isArray(roleParams[key])) {
        return roleParams[key].map((value) => `${key}[]=${value}`).join('&')
      }
    });



    let gatesParams = {
      'filter[gate_id]': [... new Set(gateNames.map(x => x))]
    }

    let gradesParams = {
      'filter[grade_id]': [... new Set(grades.map(x => x))]
    }

    let routesParams = {
      'filter[route_name]': [... new Set(routes.map(x => x))]
    }

    let classParams = {
      'filter[class_id]': [... new Set(classes.map(x => x))]
    }


    let gatesQuery =
      Object.keys(gatesParams).map(key => {
        if (Array.isArray(gatesParams[key])) {
          return gatesParams[key].map((value) => `${key}[]=${value}`).join('&')
        }
      })

    let gradesQuery = Object.keys(gradesParams).map(key => {
      if (Array.isArray(gradesParams[key])) {
        return gradesParams[key].map((value) => `${key}[]=${value}`).join('&')
      }
    })

    let routesQuery = Object.keys(routesParams).map(key => {
      if (Array.isArray(routesParams[key])) {
        return routesParams[key].map((value) => `${key}[]=${value}`).join('&')
      }
    })

    let classesQuery = Object.keys(classParams).map(key => {
      if (Array.isArray(classParams[key])) {
        return classParams[key].map((value) => `${key}[]=${value}`).join('&')
      }
    })
    //  const staticRoleQuery = "filter[role][]=bus_driver&filter[role][]=security&filter[role][]=supervisor";
    let queryArr = [...gatesQuery, ...roleQuery, ...gradesQuery, ...routesQuery, ...classesQuery];
    let query = queryArr.join('&');


    this.messageApi.filterUsers(query).pipe(map((res: any) => {
      return res.map(x => (
        {
          id: x.id,
          name: x.name,
          image_path: x.image_path,
          roles: x.roles[0].name,
          classes: x.classes,
          grades: x.grades,
        }
      ))

    })).

      subscribe(data => {
        this.setAllUsers(data)
        query = ''
      })

  }

  setFiltersOptions(options) {
    this.createMessageState.setFiltersOptions(options)
  }
  getFiltersOptions$() {
    return this.createMessageState.getFilterdOptions$()
  }

  setSelectedUsersIds(usersIds, appendFlag = true) {
    const currentSelectedUsersIds = appendFlag ? this.getSelectedUsersIds$().getValue() : [];
    this.createMessageState.setSelectedUsersId([...usersIds, ...currentSelectedUsersIds])
    // this.createMessageState.setSelectedUsersId([...usersIds])
  }
  getSelectedUsersIds$() {
    return this.createMessageState.getSelectedUsersIds$()
  }

  sendMessage(body: any) {
    return this.messageApi.sendMessageToUsers(body)
  }

}